import { RawId, type RawIdProps } from "./RawId";

function guidPreview(value: string) {
  return value.split("-")[0];
}

export interface GuidProps extends Omit<RawIdProps, "preview"> {}

export default function Guid({ value, ...rest }: GuidProps) {
  if (!value) return null;
  const preview = guidPreview(value);
  return <RawId {...rest} value={value} preview={preview} />;
}
